<template>
	<button
		class="btn-edit"
		:style="`background-color: ${background}; right: ${right}px; top: ${top}px`"
		type="button"
		@click="$emit('edit-section')"
	>
		<img :src="`/static/img/icon-${icon}.svg`" alt="">
	</button>
</template>

<script>
	export default {
		name: 'btn-edit',
		props: {
			background: {
				default: '#ffffff',
				type: String,
			},
			icon: {
				default: 'edit',
				type: String,
			},
			right: {
				default: 21,
				type: Number,
			},
			top: {
				default: 57,
				type: Number,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.btn-edit {
		border-radius: 100%;
		height: 57px;
		padding-top: 7px;
		position: absolute;
		text-align: center;
		width: 57px;
		z-index: 5;

		img {
			height: 27px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/commons/btn-edit.vue